module.exports = "<app-img-header imgUrl=\"/assets/images/img-headers/apartments.jpg\"></app-img-header>\r\n\r\n<div class=\"apartment-one-container\">\r\n  <div class=\"container\">\r\n\r\n    <div class=\"separator\"></div>\r\n\r\n    <gallery \r\n      galleryName = \"galleryApartment1\">\r\n    </gallery>\r\n\r\n    <div class=\"separator\"></div>\r\n\r\n    <a routerLink = \"/apartments\">\r\n      <p class=\"title\" translate [innerHTML]=\"'APARTMENTS.BACK' | translate\">\r\n      </p>\r\n    </a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/apartment-one/apartment-one.component.html
// module id = 776
// module chunks = 1